import { ExtendedModel, model } from 'mobx-keystone';
import { VaultModelBase } from './VaultModel.base';
import { stateToStatus } from '@ir/client/components/Device/status-helpers';

/* A graphql query fragment builders for VaultModel */
export { selectFromVault, vaultModelPrimitives, VaultModelSelector } from './VaultModel.base';

/**
 * VaultModel
 */
@model('Vault')
export class VaultModel extends ExtendedModel(VaultModelBase, {}) {
  get statusConfig() {
    return stateToStatus(this.status);
  }
}
